export class Offer {
	frequency: number;
	amount: number;
	numberOfPayments: number;
	balance: number;
	discount: number;
	totalPaid: number;
}